import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../core/pages/HomePage';
import TermsPage from '../core/pages/TermsPage';
import PrivacyPolicyPage from '../core/pages/PrivacyPolicy';
import UserLoginPage from '../authentication/pages/UserLoginPage';
import UserEmailVerificationPage from '../authentication/pages/UserEmailVerificationPage';
import UserForgotPasswordPage from '../authentication/pages/UserForgotPasswordPage';
import UserResetPasswordConfirmPage from '../authentication/pages/UserResetPasswordConfirmPage';

const CoreRouter = () => (
  <Routes>
    <Route path="" element={<HomePage />} />
    <Route path="terms" element={<TermsPage />} />
    <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
    {/*<Route path="sign-up" element={<UserSignUpPage />} />*/}
    <Route path="login" element={<UserLoginPage />} />
    <Route path="email-verification/:uidb64/:token/" element={<UserEmailVerificationPage />} />
    <Route path="forgot-password" element={<UserForgotPasswordPage />} />
    <Route path="api/users/reset/:uidb64/:token" element={<UserResetPasswordConfirmPage />} />
  </Routes>
);

export default CoreRouter;